import { baseApi } from './baseApi';

export const jackpotApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getJackpotOverview: builder.query({
      query: () => '/jackpot/overview',
      providesTags: ['Dashboard'],
    }),
  }),
});

export const { useGetJackpotOverviewQuery } = jackpotApi;
